<template><svg id="artwork" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 160">
  <g>
    <g>
      <polygon class="color-change" fill="#fd84ff"
               points="47.9 154.98 5.87 82.19 50.45 5.02 139.58 5.02 184.13 82.19 142.14 154.98 47.9 154.98"/>
      <path class="white" fill="#fff"
            d="M137,9.52l41.95,72.67-39.4,68.29h-89L11.07,82.19l42-72.67H137m5.19-9H47.86L.67,82.19,45.3,159.48h99.44l44.59-77.29L142.18.52Z"/>
    </g>
    <path id="Path_108" data-name="Path 108" class="white" fill="#fff"
          d="M118.06,40.26a3.83,3.83,0,0,1,3.06,6.13L101.89,71.86l16.87,7.41a3.83,3.83,0,0,1,1.95,5.06,3.75,3.75,0,0,1-1.23,1.53L74.23,119a3.83,3.83,0,0,1-5.33-5.39L88.13,88.14,71.26,80.73a3.84,3.84,0,0,1-2-5.06,3.78,3.78,0,0,1,1.24-1.53L115.8,41a3.85,3.85,0,0,1,2.27-.74m0-8.13A11.8,11.8,0,0,0,111,34.44L65.75,67.57A12,12,0,0,0,68,88.17l7.46,3.27-13,17.27A12,12,0,0,0,79,125.56l45.25-33.14A12,12,0,0,0,122,71.83l-7.45-3.28,13-17.26a12,12,0,0,0-9.54-19.15Z"/>
  </g>
</svg>
</template>